import heroImage from '@/assets/images/works/projects/hyperdrive/hyperdrive-logo.png' // Placeholder reuse
// Using placeholders for now
import compareLeft from '@/assets/images/works/projects/hyperdrive/hyperdrive--compare-left.mp4'
import compareRight from '@/assets/images/works/projects/hyperdrive/hyperdrive--compare-right.png'
import heroLogo from '@/assets/images/works/projects/cassian/cassian-logo.png'

export default {
  meta: {
    title: 'CASSIAN & ASSOCIATES',
    headline: 'Trusted <br> <span class="text-electric-purple">Advisors.</span>',
    label: 'Case Study 03',
    description: 'Comprehensive digital revamp for a premier audit and advisory firm in Tanzania.',
    chips: [
      { text: 'Corporate', dotColor: 'bg-orange-500' },
      { text: 'Fintech', dotColor: 'bg-blue-500' },
      { text: '2023' },
    ],
    heroImage:
      'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=1920&auto=format&fit=crop',
    heroLogo: heroLogo,
  },
  sidebar: {
    title: 'Index',
    meta: [
      { label: 'Client', value: 'Cassian & Associates' },
      { label: 'Type', value: 'Corporate Website' },
      { label: 'Role', value: 'Lead Developer & Designer' },
      { label: 'Stack', value: 'Vue 3, Tailwind, Pinia, Firebase' },
      { label: 'Location', value: 'Dar Es Salam, Tanzania (Remote)' },
      { label: 'Year', value: '2023' },
    ],
    cta: 'View Live Site',
    ctaLink: 'https://cassian.co.tz/',
    secondaryCta: 'View Code',
    secondaryCtaLink: '#',
  },
  sections: {
    overview: {
      id: 'overview',
      menuLabel: 'Summary',
      title: 'Project Context',
      highlight:
        'The core objective was to execute a comprehensive refresh of the Cassian corporate brand and website to elevate the company image and user experience.',
      cards: [
        { title: 'Client', text: 'Cassian & Associates' },
        { title: 'Industry', text: 'Tax & Corporate Services' },
        { title: 'Services', text: 'Branding, Web Dev, UX/UI' },
        { title: 'Result', text: '+40% Lead Gen' },
      ],
    },
    enfoque: {
      id: 'enfoque',
      menuLabel: 'Concept',
      label: 'The Challenge',
      title: 'Modernizing Tradition',
      description:
        'Tax firms often feel rigid. We needed to convey <strong>authority and precision</strong> while appearing modern, accessible, and tech-forward. The challenge was to balance these opposing forces into a cohesive digital identity.',
      tags: ['Rebranding', 'Vue 3', 'Performance', 'SEO'],
    },
    problema: {
      id: 'problema',
      menuLabel: 'Challenge',
      title: 'The Problem',
      description:
        "The previous digital presence did not reflect the firm's actual scale and expertise. Users found it difficult to navigate complex service offerings, leading to high bounce rates.",
      stats: [
        { value: '3.5s', label: 'Avg Load Time' },
        { value: '65%', label: 'Mobile Traffic' },
        { value: '15%', label: 'Bounce Rate' },
      ],
    },
    transformacion: {
      id: 'transformacion',
      menuLabel: 'Comparison',
      title: 'Before & After',
      beforeLabel: 'Old Site',
      afterLabel: 'New Site',
      instruction: 'Drag to compare',
      beforeImage: compareLeft,
      afterImage: compareRight,
    },
    branding: {
      id: 'branding',
      menuLabel: 'Identity',
      title: 'Visual Identity',
      description:
        'A bold, professional design language that balances trustworthiness with modern dynamism.',
      palette: [
        { name: 'Primary Orange', hex: '#FF5D16' },
        { name: 'Professional Dark', hex: '#1A1A24' },
        { name: 'Accent Blue', hex: '#00B6EA' },
        { name: 'Clean White', hex: '#FFFFFF' },
      ],
      typography: 'Filson Soft (Headings) + Noto Sans (Body)',
      gallery: [
        'https://placehold.co/600x400/1A1A24/FF5D16/png?text=Stationery',
        'https://placehold.co/600x400/1A1A24/FF5D16/png?text=Social+Media',
        'https://placehold.co/600x400/1A1A24/FF5D16/png?text=Business+Card',
        'https://placehold.co/600x400/1A1A24/FF5D16/png?text=Merch',
      ],
    },
    proceso: {
      id: 'proceso',
      menuLabel: 'Process',
      title: 'Development Process',
      subtitle: 'A Phased Approach',
      description: `
        <div class="space-y-4">
          <div><strong class="text-electric-purple text-lg block mb-1">Phase 1: Research & Analysis</strong> Thorough investigation of the Cassian brand and competition, defining specific project objectives and analyzing current web design trends.</div>
          <div><strong class="text-electric-purple text-lg block mb-1">Phase 2: Design & Development</strong> Defining visual elements (logo, palette, typography) and building the new corporate website using Vue 3 and Tailwind CSS.</div>
          <div><strong class="text-electric-purple text-lg block mb-1">Phase 3: Testing & Launch</strong> Exhaustive testing to guarantee optimal UX, followed by the official launch and implementation of the new corporate branding.</div>
        </div>
      `,
      images: [
        'https://placehold.co/600x800/1A1A24/FF5D16/png?text=Process+1',
        'https://placehold.co/600x800/1A1A24/FF5D16/png?text=Process+2',
        'https://placehold.co/600x800/1A1A24/FF5D16/png?text=Process+3',
      ],
    },
    solucion: {
      id: 'solucion',
      menuLabel: 'Gallery',
      label: 'Final Result',
      title: 'The Experience',
      images: [
        'https://placehold.co/800x1200/1A1A24/FFFFFF/png?text=Mobile+View',
        'https://placehold.co/800x1200/1A1A24/FFFFFF/png?text=Service+Page',
        'https://placehold.co/800x1200/1A1A24/FFFFFF/png?text=About+Us',
        'https://placehold.co/800x1200/1A1A24/FFFFFF/png?text=Contact',
      ],
    },
    tecnologia: {
      id: 'tecnologia',
      menuLabel: 'Tech Stack',
      title: 'Engineering',
      description: 'A modern stack architecture designed for scalability and performance.',
      categories: [
        { name: 'Design', items: ['Figma', 'Photoshop', 'Illustrator', 'Adobe Fonts'] },
        { name: 'Frontend', items: ['Vue 3', 'Composition API', 'Vite'] },
        { name: 'Styles', items: ['Tailwind CSS', 'SCSS', 'PostCSS'] },
        { name: 'State/Logic', items: ['Pinia', 'Firebase', 'Axios'] },
      ],
    },
  },
}
